import firebase, {db, auth, fc} from './connection'

export default {
    getAllByPending(factor) {
        let ref;

        if (factor == 'master') {
            ref = db.collection('users').where('role.pending', '==', true);
        }
        if (factor.role == 'director' || factor.role == 'captain') {
            ref = db.collection('users').where('role.pending', '==', true).where('applyingFor', '==', factor.center)
        }
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getAllLivestreamers() {
        let ref = db.collection('users').where('livestream', '==', true).where('role.student', '==', true);
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getAllNotPending(factor) {
        let ref;

        if (factor == 'master') {
            ref = db.collection('users').where('role.pending', '==', false);
        }
        if (factor.role == 'director' || factor.role == 'captain') {
            ref = db.collection('users').where('role.pending', '==', false).where('center', '==', factor.center)
        }
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getByRole(str) {
        let ref = db.collection('users').where('role.'+str, '==', true)
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getByCenter(center) {
        let ref = db.collection('users').where('center', '==', center)
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getGroupMates(group, center) {
        let ref = db.collection('users').where('center', '==', center).where('group', '==', group).where('role.student', '==', true);
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getTeamMates(team) {
        let ref = db.collection('users').where('team', '==', team).where('role.student', '==', true);
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getCaptains() {
        let ref = db.collection('users').where('role.captain', '==', true);
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    getDirectorWithoutCenter(str) {
        let ref = db.collection('users').where('role.'+str, '==', true).where('center', '==', null)
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    setColor(uid, color) {
        let ref = db.collection('users').doc(uid);

        return ref.update({color: color})
                    .then( () => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    },

    setTexture(uid, texture) {
        let ref = db.collection('users').doc(uid);

        return ref.update({texture: texture})
                    .then( () => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    },

    setTeam(uid, team) {
        let ref = db.collection('users').doc(uid);

        return ref.update({team: team})
                    .then( () => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    },

    setProfile(uid, status, applyingFor) {
        let ref = db.collection('users').doc(uid);

        let obj = {
                role: {
                    pending: false,
                    [status]: true
                },
                center: applyingFor,
                applyingFor: null
            }

        return ref.update(obj)
                    .then( () => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    },

    blockProfile(uid, role) {
        let ref = db.collection('users').doc(uid);
        
        return ref.update({role: role})
                    .then( () => {
                        return true;
                    })
                    .catch(error => {
                        return error;
                    });
    },

    setGroupAndTeam(uid, model) {
        let ref = db.collection('users').doc(uid);

        let obj = {
            group: model.group,
            team: model.team
        }

        return ref.update(obj)
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    setAwards(uid, awards) {
        let ref = db.collection('users').doc(uid);

        return ref.update({awards: awards})
                .then( () => {
                    return true;
                })
                .catch(error => {
                    return error;
                });
    },

    getAll(uid) {
        let ref = db.collection('users').doc(uid).collection('clients');
    
        return ref.get()
                .then(query => {
                    return {status: true, query: query};
                })
                .catch(error => {
                    return error;
                });
    },

    get(uid) {
        let ref = db.collection('users').doc(uid);
    
        return ref.get()
                .then(doc => {
                    if (doc.exists) {
                        return {status: true, doc: doc};
                    } else {
                        return {status: 'not-exists'};
                    }
                })
                .catch(error => {
                    return error;
                });
    },

    add(uid, model) {
        let ref = db.collection('users').doc(uid).collection('clients');

        model.celebs = false;
        model.policies = false;
    
        return ref.add(model)
                .then(doc => {
                    return {status: true, id: doc.id};
                })
                .catch(error => {
                    return error;
                });
    },

    demoMail() {
        let demoMail = fc.httpsCallable('demoMail');
        demoMail();
    }
}